import { useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/stores/authStore'

export function useSession() {
  const { setAccessToken } = useAuthStore((state) => state.auth)

  useEffect(() => {
    async function fetchSession() {
      const { data, error } = await supabase.auth.getSession()
      if (error) {
        console.error('Erro ao buscar sessão:', error.message)
      }

      if (data?.session) {
        setAccessToken(data.session.access_token)
      }
    }

    fetchSession()

    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        setAccessToken(session.access_token)
      } else {
        setAccessToken('')
      }
    })

    return () => {
      authListener.subscription.unsubscribe()
    }
  }, [setAccessToken])

  return { session: useAuthStore((state) => state.auth.session), loading: !useAuthStore((state) => state.auth.session) }
}
